/**
 * The frontend and API can deploy independently. CircleCI pipeline numbers are
 * monotonic, so the larger embedded number identifies the newest deployed side.
 */
export function latestDeploymentVersion(
  apiVersion?: string,
  frontendVersion?: string,
): string {
  const numberedVersions = [apiVersion, frontendVersion]
    .filter((version): version is string => /^\d+$/.test(version ?? ""))
    .map((version) => ({ number: BigInt(version), version }));

  if (numberedVersions.length > 0) {
    return numberedVersions.reduce((latest, candidate) =>
      candidate.number > latest.number ? candidate : latest,
    ).version;
  }

  return apiVersion || frontendVersion || "Unknown";
}
